<template>
  <div class="p-4 flex flex-col space-y-4">
    <div v-if="selectedDomainManagementFlow == ''">
      <div class="flex flex-row w-full mb-6 gap-5 justify-start">
        <div class="flex flex-col w-1/2">
          <gd-icon-radio
            v-model="domainManagementFlow"
            option-name="GroovePages Subdomain"
            option-icon="brandIcon"
            :disabled="freeUser || startUpUser"
            :overlay="overlayMessage"
          >
          <template>
            <div slot="description">
              https://<span class="font-bold text-primary">CHOOSENAME</span>.{{ groovepagesDomain }}
            </div>
          </template>
          </gd-icon-radio>
        </div>
        <div class="flex flex-col w-1/2">
          <gd-icon-radio
            v-model="domainManagementFlow"
            option-name="Custom Domains"
            option-icon="DomainsIcon"
          >
            <template slot="description">
              https://<span class="font-bold text-primary">YOURDOMAIN</span>.com
            </template>
          </gd-icon-radio>
        </div>
      </div>
      <div class="mt-2 flex flex-row justify-center">
        <gd-button 
          variant="primary"
          size="auto"
          @click="selectedDomainManagementFlow = domainManagementFlow"
        >
          {{ $t('frontend_manage') }}
        </gd-button>
      </div>
    </div>
    <div v-else-if="selectedDomainManagementFlow == 'GroovePages Subdomain'">
      <subdomain-editor @clickedBackButton="selectedDomainManagementFlow = ''"/>
    </div>
    <div v-else>
      <custom-domains
        :domains="userDomains"
        @clickedBackButton="selectedDomainManagementFlow = ''"
      ></custom-domains>
    </div>
  </div>
</template>

<script>
import Auth from '@groovepages/gd-lib/auth';
import Notify from '../notify';
import AccountDomainRecordEditor from './AccountDomainRecordEditor';
import GdButton from './Button';
import ConfirmModal from './ConfirmModal';
import CustomDomains from './CustomDomains';
import GdIconRadio from './IconRadio';
import GdModal from './Modal';
import SubdomainEditor from './SubdomainEditor';
import TextInput from './TextInput';

export default {
  name: 'AccountDomains',
  components: {
    GdModal,
    GdIconRadio,
    ConfirmModal,
    AccountDomainRecordEditor,
    GdButton,
    TextInput,
    SubdomainEditor,
    CustomDomains,
  },
  data() {
    return {
      domainManagementFlow: 'Custom Domains',
      userDomains: [],
      selectedDomainManagementFlow: '',
      setUpDomain: false,
      setUpCustomDomain: false,
      showCname: false,
      setupGrooveDomain: false,
      errorMsg: '',
      domainColumns: [
        this.$t('frontend_type'),
        this.$t('frontend_name'),
        this.$t('frontend_content'),
        'TTL',
        'Proxy'
      ],
      showCreateDomain: false,
      showRecordEditor: false,
      loadingDomains: false,
      loadingRecords: false,
      savingRecord: false,
      togglingProxy: undefined,
      selectedRecord: undefined,
      deletingRecord: undefined,
      deletingDomain: undefined,
      selectedDomain: undefined,
      newDomain: {
        domain: '',
        hosted: true,
        platform: 'pages',
      },
      addingDomain: undefined,
      grooveSellLegacyDomains: [],
    };
  },
  computed: {
    startUpUser() {
        if(Auth.fetchPlanName() && Auth.fetchPlanName().toLowerCase() == 'startup')
        {
            return true;
        }
        return false;
    },
    freeUser() {
      return this.$store.getters.isLiteUser && !this.$store.getters.isWhitelistUser;
    },
    upgradeUrl() {
      let user = Auth.authenticatedUser();
      return window.gdEnv[`UPGRADE_URL_${user?.metadata?.region?.toUpperCase()}`] || window.gdEnv[`UPGRADE_URL`];
    },
    overlayMessage() {
      return (this.freeUser || this.startUpUser) && this.$t('frontend_gduikit_account_domain_overlay_msg', { link: this.upgradeUrl });
    },
    groovepagesDomain() {
      return window.gdEnv['VUE_APP_GROOVEPAGES_URL']?.match(/\/\/(.+)$/)[1] || 'groovepages.com'
    }
  },
  methods: {
    showError(e) {
      console.error(e);
      if (e) {
        if (e && e.response && e.response.data.errors) {
          return Notify.fail(
            e.response.data.errors[0].message,
            e.response.data.errors.map(({ message }) => message).join('. ')
          );
        }
        return Notify.fail(e.message);
      }
    },
    resetDomain() {
      this.newDomain = {
        domain: '',
        hosted: true,
        platform: 'pages',
      };
    },
    validURL(str) {
      const pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      ); // fragment locator
      return !!pattern.test(str);
    },
  },
};
</script>
<style scoped>
p {
  color: #191d3a;
}

hr {
  border-color: #a4a8c0;
}

button {
  width: fit-content;
  padding: 10px;
  white-space: nowrap;
}

td,
th {
  border-left: 0px;
  border-right: 0px;
  border-color: #dcdcea;
}

th {
  color: #a4a8c0;
}

td {
  color: #292b49;
  word-break: break-all;
}

td:nth-child(3) {
  max-width: 150px;
}

.gp-slide {
  max-height: 500px;
  transition: max-height 0.25s ease-in;
}
.gp-slide * {
  transition: opacity 0.4s ease-in;
}
.gp-hide {
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
}
.gp-hide * {
  opacity: 0;
}
</style>
